export enum PubSubChannelPrefix {
  GUESTLIST = 'TL_PRO_VENUE_GUESTLIST_',
  RESERVATION = 'TL_PRO_VENUE_RESERVATION_',
  INVENTORY = 'TL_PRO_VENUE_INVENTORY_',
  AVAILABLE_LAYOUT_TABLE = 'TL_PRO_VENUE_AVAILABLE_LAYOUT_TABLE_',
  CUSTOMER_CHAT_MESSAGE = 'TL_PRO_CUSTOMER_CHAT_MESSAGE_',
  CUSTOMER_CHAT_THREAD = 'TL_PRO_CUSTOMER_CHAT_THREAD_',
  CUSTOMER_SESSION = 'TL_PRO_CUSTOMER_SESSION_',
  CHAT_IS_TYPING = 'TL_PRO_USER_CHAT_IS_TYPING_',
  VENUE = 'TL_PRO_VENUE_',
}

export enum PubSubAdminChannel {
  WEB_APP = 'TL_PRO_ADMIN_WEB_APP',
  TPRO_MOBILE = 'TL_PRO_ADMIN_TPRO_MOBILE',
  TL_WEB = 'TL_PRO_ADMIN_TL_WEB',
}
